// Iconos de la interfaz. Mismo criterio que en assets/items: se importan uno a
// uno para que la build avise si falta alguno.
import calendar from "./calendar.png";
import cross from "./cross.png";
import download from "./download.png";
import englishFlag from "./english_flag.png";
import globe from "./globe.png";
import logout from "./logout.png";
import minus from "./minus.png";
import plus from "./plus.png";
import radioButtonEmpty from "./radio_button_empty.png";
import radioButtonFull from "./radio_button_full.png";
import romanianFlag from "./romanian_flag.png";
import smile from "./smile.png";
import spanishFlag from "./spanish_flag.png";

export { calendar, cross, download, globe, logout, minus, plus, radioButtonEmpty, radioButtonFull, smile };

// Por codigo de idioma de i18next.
export const languageFlags = {
  en: englishFlag,
  es: spanishFlag,
  ro: romanianFlag,
};
